export default __webpack_public_path__ + "../css/ks-styles.css";